import { render, staticRenderFns } from "./IconCopper.vue?vue&type=template&id=29786888&scoped=true&"
import script from "./IconCopper.vue?vue&type=script&lang=js&"
export * from "./IconCopper.vue?vue&type=script&lang=js&"
import style0 from "./IconCopper.vue?vue&type=style&index=0&id=29786888&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29786888",
  null
  
)

export default component.exports